import { type IconProps, VOutlineIcon } from '@carboncopyco/icons';
import { DropdownItem, TextBase, TextCaption } from '@carboncopyco/ui';
import classNames from 'classnames';
import React, { type ReactElement } from 'react';

export interface IShareDropdownItem {
  id: string | number;
  label: string;
  description: string;
  icon: ReactElement<IconProps>;
  disabled?: boolean;
  tooltip?: string;
}

interface ShareDropdownItemProps extends IShareDropdownItem {
  onClick: () => void;
  isSelected: boolean;
}

export const ShareDropdownItem = ({
  onClick,
  label,
  isSelected,
  description,
  icon,
  disabled,
}: ShareDropdownItemProps) => {
  return (
    <DropdownItem
      onClick={onClick}
      disabled={disabled}
    >
      <div
        className={classNames('flex items-center', {
          'cursor-not-allowed text-ds-natural-300': disabled,
        })}
      >
        <div className="p-5 pr-4">{React.cloneElement(icon, { size: 30 })}</div>
        <div className="flex flex-1 flex-col">
          <div className="h-7">
            <TextBase
              label={label}
              color={disabled ? 'text-ds-natural-300' : 'text-ds-natural-600'}
            />
          </div>
          <TextCaption
            label={description}
            color="text-ds-natural-300"
          />
        </div>
        <div className="p-5">
          {isSelected ? (
            <VOutlineIcon size={30} />
          ) : (
            <div className="h-7 w-7" />
          )}
        </div>
      </div>
    </DropdownItem>
  );
};
